import $ from 'jquery';
import LP from '../0-lp';

LP.dlgSendEmails = {
    prepare: function (selector, params) {
        $(selector).click(function () {
            LP.Dialog.open($.extend(params, {
                name: 'sendEmail',
                ajax: $(this).attr('url'),
                request: $(this).attr('url_params'),
                title: this.title,
                sizeable: true,
                width: 380,
                height: 280
            }));
            return false;
        });
    }
};